import Cookies from 'js-cookie'

const AccessTokenKey = 'access_token'
const RefreshTokenKey = 'refresh_token'
const LostFindInfo = 'lost_find_info'
const SearchValue = 'search_value'
const forever = 'forever'

export function getAccessToken() {
  return Cookies.get(AccessTokenKey)
}

export function setAccessToken(token) {
  return Cookies.set(AccessTokenKey, token,{ expires: 180 })
}

export function removeAccessToken() {
  return Cookies.remove(AccessTokenKey)
}
export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey)
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token,{ expires: 180 })
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey)
}

export function setLostFindInfo(Info){
  return Cookies.set(LostFindInfo,Info)
}

export function getLostFindInfo(){
  return Cookies.get(LostFindInfo)
}
// 存放搜索值
export function setSearchValue(value){
  return Cookies.set(SearchValue,value)
}
// 取搜索值
export function getSearchValue(){
  return Cookies.get(SearchValue)
}



export function setforever(isforever){
  return Cookies.set(forever,isforever,{ expires: 180 })
}

export function getforever(){
  return Cookies.get(forever)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js


// WEBPACK FOOTER //
// ./src/utils/auth.js